import { render, staticRenderFns } from "./wsh_main.vue?vue&type=template&id=0fb0eaa1&scoped=true&"
import script from "./wsh_main.vue?vue&type=script&lang=js&"
export * from "./wsh_main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb0eaa1",
  null
  
)

export default component.exports